import { Constants } from "./constants";

export class BookTemplate {

    public type: String = 'bookTemplate';
    public cover = {
        "type": 0,//type - 0 for Images and type - 1 for templates
        "thumbUrl": '',
        "contentDocId": ''
    };
    public page = {
        "type": 0,
        "thumbUrl": '',
        "contentDocId": ''
    };

    public back = {
        "type": 0,
        "thumbUrl": '',
        "contentDocId": ''
    };
    public _id: String = "";
    public templateId: String = "";
    public owner: String = Constants.USER;


}



// WEBPACK FOOTER //
// ./src/app/shared/models/bookTemplate.ts